module.exports = __webpack_public_path__ + "static/media/Steve Cona Headshot_1610703151624.10fe095a.png";